// extracted by mini-css-extract-plugin
export default {"player":"_31kxd","player-loading":"_1w-p6","playerLoading":"_1w-p6"};